<template>
  <div>
    <div class="line"></div>
    <accordion show-divider
      :is-open="true"
    >
      <template v-slot:title>
        <div class="flex gap-3">
          <p class="font-bold">Independent Contractor Information</p>
        </div>
      </template>
      <div class="text-jet">
        <p class="text-base text-darkPurple font-bold">Residency Status</p>
        <div class="flex gap-3 my-3">
          <radio-button :options="residencyStatusOptions" class="inline-block" :disabled="!edit"
            v-model="employment.residencyStatus" row-gap="gap-y-1" space-between="mr-2"/>
        </div>

        <p class="text-base text-darkPurple font-bold">Contractor Type</p>
        <div class="flex gap-0 mt-3">
          <radio-button :options="contractorTypeOptions" class="inline-block" :disabled="!edit"
            v-model="employment.contractorType" row-gap="gap-y-0"/>
        </div>

        <div v-if="employment.contractorType === 'business'" class="w-full">
          <div class="line"></div>
          <p class="text-base text-darkPurple font-bold uppercase">
            business registration details
          </p>
          <div class="grid grid-cols-12 gap-4 text-darkPurple mt-3">
            <div class="col-span-3">
              <c-text placeholder="--Enter--" :disabled="!edit" label="Business Name" v-model="employment.businessName" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="--Enter--" :disabled="!edit" label="Business Registration Number" v-model="employment.businessRegNumber" />
            </div>
            <div class="col-span-3 relative">
              <c-text placeholder="" :disabled="!edit" label="CAC Document"/>
              <FilesUpload :file="CACDocumentfile"
                :edit="edit"
                type="CACDocumentfile"
                @file-update="fileUpdate"
              />
            </div>
          </div>

          <div class="line"></div>
          <p class="text-base text-darkPurple font-bold uppercase">
            business Address
          </p>
          <div class="grid grid-cols-12 gap-6 text-darkPurple mt-3">
            <div class="col-span-3">
              <c-select placeholder="--Enter--" :options="countrySelect"
                label="Country" v-model="employment.businessCountry" :disabled="!edit" />
            </div>
            <div class="col-span-3">
              <c-select placeholder="--Enter--" label="State"
                :options="$store.state.states" v-model="employment.businessState" :disabled="!edit" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="--Enter--" :disabled="!edit" label="City" v-model="employment.businessCity" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="--Enter--" :disabled="!edit" label="Address" v-model="employment.businessAddress" />
            </div>
            <div class="col-span-3">
              <c-text placeholder="--Enter--" :disabled="!edit" label="Postal Code" v-model="employment.businessPostalCode" />
            </div>
            <div class="col-span-3 relative">
              <div class="absolute left-32 top-0" @mouseenter="onEnter" @mouseleave="onLeave">
                <Icon
                  icon-name="red-warning-icon"
                  size="xs" class="cursor-pointer"
                />
                <ToolTip v-if="isProofOfAddress" style="width: 239px !important" left="-107px">
                  <p class="w-full text-xs text-white text-left">
                    Upload a valid document showing your current business or residential address.
                    Acceptable documents include utility bills, tenancy agreements,
                    or bank statements issued within the last 3 months.
                  </p>
                </ToolTip>
              </div>
              <c-text placeholder="" :disabled="!edit" label="Proof of Address" />
              <FilesUpload :file="proofOfAddressFile"
                :edit="edit"
                type="proofOfAddressFile"
                @file-update="fileUpdate"
              />
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="w-full">
          <p class="text-base text-darkPurple font-bold uppercase">
            TAX Information
          </p>
          <div class="grid grid-cols-12 gap-6 text-darkPurple mt-3">
            <div class="col-span-3">
              <c-text placeholder="--Enter--" :disabled="!edit" label="Tax Identification Number" v-model="employment.taxIdentificationNumber" />
            </div>
            <div class="col-span-3 relative" v-if="employment.contractorType === 'business'">
              <c-text placeholder="" :disabled="!edit" label="Tax Clearance Certificate" />
              <FilesUpload :file="taxCertFile"
                :edit="edit"
                type="taxCertFile"
                @file-update="fileUpdate"
              />
            </div>
          </div>
        </div>

        <div class="line"></div>
      </div>
    </accordion>
  </div>
</template>

<script>
// import axios from 'axios';
import Accordion from "@/components/Accordion";
import RadioButton from "@/components/RadioButton";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import ToolTip from '@/components/ToolTip';
import FilesUpload from "./filesUpload";

export default {
  components: { Accordion, RadioButton, CText, CSelect, ToolTip, FilesUpload  },
  name: "EmpIndContractor",
  props: {
    employment: {
      type: Object,
      default: () => { },
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProofOfAddress: false,
      countrySelect: [],
      residencyStatusOptions: [
        {
          name: "Resident",
          radioName: "residency",
          value: "resident",
        },
        {
          name: "Non-Resident",
          radioName: "residency",
          value: "non-resident",
        },
      ],
      contractorTypeOptions: [
        {
          name: "Individual",
          radioName: "contractor",
          value: "individual",
        },
        {
          name: "Registered Business Name",
          radioName: "contractor",
          value: "business",
        },
      ],
         mimeType: {
          "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
          "vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
          "vnd.openxmlformats-officedocument.presentationml.presentation": "ppt",
          "vnd.ms-powerpoint": "ppt",
          "pptx": "ppt"
        },
        imageSizeMB: 0,
        uploading: false,
        CACDocumentfile: [],
        proofOfAddressFile: [],
        taxCertFile: [],
    };
  },
  methods: {
    onEnter(){
      this.isProofOfAddress = true;
    },
    onLeave(){
      this.isProofOfAddress = false;
    },
    fileUpdate(file, type){
      if(type === 'CACDocumentfile'){
        this.CACDocumentfile = file;
        this.$emit('employee-file-update', this.CACDocumentfile, 'CACDocumentfile')
      }
      if(type === 'proofOfAddressFile'){
        this.proofOfAddressFile = file;
        this.$emit('employee-file-update', this.proofOfAddressFile, 'proofOfAddressFile')
      }
      if(type === 'taxCertFile'){
        this.taxCertFile = file;
        this.$emit('employee-file-update', this.taxCertFile, 'taxCertFile')
      }
    },
    isValidFile(fileUrl, fileSize, fileType, fileName) {
      const isValid = fileUrl && fileSize && fileType && fileName

      return isValid
        ? [{
            fileUrl,
            fileSize,
            mimeType: fileType.split('/')[1],
            fileName
          }]
        : []
    }
  },
  mounted() {
    this.countrySelect = this.$store.state.countries.map((element) => ({
      id: element.Alpha3Code,
      name: element.Name,
    }));
    const { cacFileUrl, cacFileSize, cacFileType,  cacFileName,
      taxCertificateFileUrl, taxCertificateFileSize, taxCertificateFileType, taxCertificateFileName,
      businessProofOfAddress, businessProofOfAddressFileSize, businessProofOfAddressFileType, businessProofOfAddressFileName
    } = this.employment;

    this.CACDocumentfile = this.isValidFile(cacFileUrl, cacFileSize, cacFileType, cacFileName)
    this.proofOfAddressFile = this.isValidFile(businessProofOfAddress, businessProofOfAddressFileSize, businessProofOfAddressFileType, businessProofOfAddressFileName)
    this.taxCertFile = this.isValidFile(taxCertificateFileUrl, taxCertificateFileSize, taxCertificateFileType, taxCertificateFileName)
  }
};
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 32px auto;
  border-radius: 10px;
  padding: 0;
}
</style>
